const ITEMS = [
  "Hematopathology", "Bone Marrow Reporting", "Flow Cytometry", "Complete Blood Count",
  "Coagulation Studies", "Digital X-Ray", "Ultrasound", "Health Packages",
  "Home Sample Collection", "B2B Lab Reporting", "ECG", "Hemozy+ Membership",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative bg-[#0F2942] border-y border-white/10 py-5 overflow-hidden marquee-mask" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee-slow items-center">
        {row.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="text-slate-300 text-sm lg:text-base font-medium tracking-wide whitespace-nowrap px-6" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              {item}
            </span>
            <svg viewBox="0 0 20 20" className="w-3 h-3 shrink-0">
              <path d="M10 2 C7 6.5, 4.5 9, 4.5 12 a5.5 5.5 0 0 0 11 0 C15.5 9, 13 6.5, 10 2 Z" fill="#D92638" />
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
}
